module.exports = __webpack_public_path__ + "static/media/spoke-gray.15d552e5.svg";